<template>
  <div>
    <toggle-button
      v-if="isShowMarkCompleteButton"
      :isset="finished"
      color="green"
      issetText="Mark Finished"
      issetIcon="done_outline"
      reverseText="Finished"
      reverseIcon="verified"
      @toggle="toggleArchive"
    />
    <g-button v-if="isCancelButton" label="Cancel" type="error" :disabled="isCancelButtonDisabled" @onclick="cancel" />
  </div>
</template>

<script>
export default {
  computed: {
    booking() {
      return this.$store.getters["FinanceReportStore/booking"];
    },
    bookingId() {
      return this.$store.getters["FinanceReportStore/booking_id"];
    },
    bookingStatus() {
      return this.$store.getters["FinanceReportStore/booking_status"];
    },
    finished() {
      return this.$store.getters["FinanceReportStore/report_finished"];
    },
    paymentHistory() {
      return this.$store.getters["FinanceReportStore/payment_history"];
    },
    extraExpenses() {
      return this.$store.getters["FinanceCompileStore/extra_expenses"];
    },
    isShowMarkCompleteButton() {
      return this.bookingStatus == 1;
    },
    isCancelButton() {
      return this.bookingStatus == 0;
    },
    isCancelButtonDisabled() {
      const hasPaymentHistoryDeposit = this.paymentHistory.some((item) => item.isdeposit == 1);
      const deposits = this.extraExpenses.filter((item) => item.expense_type === "DEPOSIT");
      const reconciledDeposits = deposits.filter((item) => item.reconciled == true);
      const hasUnreconciledDeposits = deposits.length != reconciledDeposits.length;
      return hasPaymentHistoryDeposit || hasUnreconciledDeposits;
    },
  },
  methods: {
    toggleArchive(val) {
      this.$root.$loading.open("Updating...");
      this.$store
        .dispatch("FinanceReportStore/toggleFinished", {
          booking_id: this.bookingId,
          finished: val,
        })
        .then(() => {
          this.$root.$loading.end();
          this.$root.$success("Updated Report");
        })
        .catch((err) => this.$root.$error(err));
    },
    cancel() {
      let updateBooking = { ...this.booking };
      updateBooking.status = -1;

      this.$store
        .dispatch("FinanceReportStore/updateBooking", {
          booking_id: this.bookingId,
          booking: updateBooking,
        })
        .then((v) => {
          this.$root.$loading.end();
          this.$root.$success("Updated Booking");
        })
        .catch((err) => {
          this.$root.$error(err);
        });
    },
  },
};
</script>
